// Footer Newsletter
import React, {Component} from 'react';

import MailchimpSubscribe from "react-mailchimp-subscribe"

const url = '//rascals.us4.list-manage.com/subscribe/post?u=830366d4d880a505e61e35f9c&amp;id=7f12b101e9';

const CustomForm = ({ status, message, onValidated }) => {
  let email;
  const submit = () =>
    email &&
    email.value.indexOf("@") > -1 &&
    onValidated({
      EMAIL: email.value,
    });

    return (
        <div>
            {status === "sending" && <div className="newsletter__message newsletter__message--sending">sending...</div>}
            {status === "error" && (
                <div className="newsletter__message newsletter__message--error"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
            {status === "success" && (
                <div className="newsletter__message newsletter__message--success"
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            )}
            <input
                ref={node => (email = node)}
                type="email"
                placeholder="Your email"
            />
            <button onClick={submit}>
                Submit
            </button>
        </div>
    );
};

class Newsletter extends Component {
    render () {
        return (
            <div className="newsletter">
                <span>Subscribe to our newsletter to get exclusive news, updates, free stuff and new releases by email. We respect your inbox, only the good stuff.</span>
                
                <MailchimpSubscribe
                  url={url}
                  render={({ subscribe, status, message }) => (
                    <CustomForm
                      status={status}
                      message={message}
                      onValidated={formData => subscribe(formData)}
                    />
                  )}
                />

            </div>

        );
    }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./src/containers/Footer/Newsletter.js